import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'lib-delete-user-modal',
    templateUrl: './delete-user-modal.component.html',
    styleUrls: ['./delete-user-modal.component.css'],
    standalone: false
})
export class DeleteUserModalComponent implements OnInit {
  username: string;

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit() {}
}
